import React from 'react'

export default function Header() {
  return (
    <div>
        <h1>Header Content</h1>
    </div>
  )
}
